import React from "react";
import notify from "devextreme/ui/notify";
import Form, { SimpleItem, GroupItem, Label } from "devextreme-react/form";
import { Button } from "devextreme-react";
import UserInfo from "../../UserInfo";
import api from "../../api-axios";
import showReport from "../../showReport";

const template = {
    cnpj: undefined,
    exercicioInicial: undefined,
    mesInicio: undefined,
    exercicioFinal: undefined,
    mesFinal: undefined,
};

export default class DeclaracoesSimplesNacional extends React.Component {
    constructor(props) {
        super(props);
        console.log("props declaracao", props);
        this.state = { ...template };

        this.ok = this.ok.bind(this);
        this.cancel = this.cancel.bind(this);

        const meses = [
            { id: 1, descricao: "JANEIRO" },
            { id: 2, descricao: "FEVEREIRO" },
            { id: 3, descricao: "MARÇO" },
            { id: 4, descricao: "ABRIL" },
            { id: 5, descricao: "MAIO" },
            { id: 6, descricao: "JUNHO" },
            { id: 7, descricao: "JULHO" },
            { id: 8, descricao: "AGOSTO" },
            { id: 9, descricao: "SETEMBRO" },
            { id: 10, descricao: "OUTUBRO" },
            { id: 11, descricao: "NOVEMBRO" },
            { id: 12, descricao: "DEZEMBRO" },
        ]
        this.mesesOptions = {
            searchEnabled: false,
            dataSource: meses,
            valueExpr: "id",
            displayExpr: "descricao",
        };
        this.boolOptions = {
            searchEnabled: false,
            dataSource: [
                { id: true, descricao: "SIM" },
                { id: false, descricao: "NÃO" },
            ],
            valueExpr: "id",
            displayExpr: "descricao",
        }
    }

    componentDidMount() {
        const dataCorrente = new Date();
        this.setState({
            mesInicio: 1,
            mesFinal: dataCorrente.getMonth(),
            exercicioInicial: dataCorrente.getFullYear(),
            exercicioFinal: dataCorrente.getFullYear()
        });
    }

    render() {
        return (
            <React.Fragment>
                <div className={"content-block dx-card responsive-paddings"}>
                    <Form formData={this.state} colCount={1}>
                        <GroupItem caption="Declaração do Simples Nacional" >
                            <SimpleItem dataField="cnpj">
                                <Label text="CNPJ"/>
                            </SimpleItem>
                            <SimpleItem dataField="exercicioInicial">
                                <Label text="Exercício Inicial"/>
                            </SimpleItem>
                            <SimpleItem
                                dataField={"mesInicio"}
                                editorType={"dxSelectBox"}
                                editorOptions={this.mesesOptions}>
                                <Label text="MêscInicial"/>
                            </SimpleItem>
                            <SimpleItem dataField="exercicioFinal">
                                <Label text="Exercício Final"/>
                            </SimpleItem>
                            <SimpleItem
                                dataField={"mesFinal"}
                                editorType={"dxSelectBox"}
                                editorOptions={this.mesesOptions}>
                                <Label text="Mês Final"/>
                            </SimpleItem>
                        </GroupItem>
                    </Form>
                    <div
                        style={{
                            display: "flex",
                            marginTop: "25px",
                            justifyContent: "center",
                            alignContent: "center",
                            justifyItems: "center",
                            alignItems: "center",
                        }}
                    >
                        <div style={{ display: "inline-block" }}>
                            <Button
                                width={150}
                                text="Voltar"
                                icon={"back"}
                                onClick={this.cancel}
                            />
                        </div>
                        <div style={{ display: "inline-block", marginLeft: "5px" }}>
                            <Button
                                width={150}
                                text="Imprimir"
                                type="success"
                                icon={"print"}
                                onClick={this.ok}
                            />
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    ok() {
        const entidade = { ...this.state, prefeituraId: UserInfo.getPrefeitura() };
        console.log(entidade);
        showReport("/report/declaracao_sn", entidade);
    }

    cancel() {
        if (this.props.location.origem != undefined) {
            const origem = this.props.location.origem;
            this.props.history.push(origem);
        }
        else {
            this.props.history.goBack();
        }

    }
}
